// extracted by mini-css-extract-plugin
module.exports = {"text-red":"style_text-red__Eoumd","skeleton_loader":"style_skeleton_loader__3SRF5","skeleton-animation":"style_skeleton-animation__3Szzm"};